
const WhatsappBtn = () => {
  return (
    <div className="ml-auto mt-[40px] mb-[30px] cursor-pointer flex items-center bg-[#33CC33] rounded-[10px] w-[200px] p-[4px_10px]">
        <img src="/images/whatsap_icon.png" alt="whatsapp" />
        <span className="inline-block ml-[3px] text-white text-[12px] font-[500]">
          Require more slots?
          Get in touch with us!
        </span>
      </div>
  )
};

export default WhatsappBtn;
